import {fetchApi} from "../fetch";
import {API_URL} from "../../constants/axios";

export const checkChannel = async (searchId) => {
    const res = await fetchApi.get(API_URL.CHANNEL_DUPLICATE + `?searchId=${searchId}`)
    return res.data;
}

export const getPublicId = async (searchId) => {
    const res = await fetchApi.get(API_URL.CHANNEL_PUBLIC_Id + `?searchId=${searchId}`)
    return res.data;
}

export const getProfile = async () => {
    const res = await fetchApi.get(API_URL.CHANNEL_PROFILE)
    return res.data;
}